import StorageIcon from '@material-ui/icons/FileCopy';
import StorageList from './storageList.js';
import StorageCreate from './storageCreate.js';

export default {
    create: StorageCreate,
    icon: StorageIcon,
    list: StorageList,
};